import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../partage/api/client';
import { relireApres } from '../partage/relectures';

/**
 * « Remettre à sa place » (chantier deplacer-les-bulles, ticket 04) : la place gardée de la bulle,
 * pour la profondeur affichée seulement, s'efface ; puis la carte se relit, et le serveur la replace.
 * Ses places des autres profondeurs restent. Effacée ou refusée, on relit : la carte dit le vrai.
 */
export function useRemettreASaPlace(profondeur: number) {
  const client = useQueryClient();
  return useCallback(
    (id: string) => {
      void api
        .remettreASaPlace(id, profondeur)
        .catch(() => undefined)
        .then(() => relireApres(client, 'remettreASaPlace'));
    },
    [client, profondeur]
  );
}
